import React from 'react';
import { usePostHog } from 'posthog-js/react';
import { captureReactError } from '../utils/posthogUtils';

class ErrorBoundaryInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('React Error Boundary caught error:', error, errorInfo);

        // Capture error in PostHog
        if (this.props.posthog) {
            captureReactError(this.props.posthog, error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '3rem',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        maxWidth: '600px',
                    }}>
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#e53935"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ margin: '0 auto 1.5rem' }}
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                        <h1 style={{
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            marginBottom: '1rem',
                            color: '#333',
                        }}>
                            Something went wrong
                        </h1>
                        <p style={{
                            color: '#666',
                            marginBottom: '2rem',
                            lineHeight: '1.6',
                        }}>
                            We're sorry, but something unexpected happened. The error has been logged and we'll look into it.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                backgroundColor: '#e30613',
                                color: 'white',
                                padding: '0.75rem 2rem',
                                borderRadius: '6px',
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#c00510'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#e30613'}
                        >
                            Reload Page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

// Wrapper component to inject PostHog
function ErrorBoundary({ children }) {
    const posthog = usePostHog();
    return (
        <ErrorBoundaryInner posthog={posthog}>
            {children}
        </ErrorBoundaryInner>
    );
}

export default ErrorBoundary;
